"use client";

import { InputHTMLAttributes, forwardRef } from "react";

interface SwitchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
  description?: string;
}

const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, description, className = "", id, ...props },
  ref
) {
  const switchId =
    id || `switch-${label?.toLowerCase().replace(/\s/g, "-") || "toggle"}`;

  return (
    <div className={`flex items-start gap-3 ${className}`}>
      <label
        htmlFor={switchId}
        className="relative inline-flex h-6 w-11 items-center cursor-pointer"
      >
        <input
          ref={ref}
          type="checkbox"
          id={switchId}
          className="peer sr-only"
          {...props}
        />
        <span className="block w-11 h-6 bg-[var(--color-border)] rounded-full transition-colors peer-checked:bg-[var(--color-accent-yellow-dark)] peer-focus:ring-2 peer-focus:ring-[var(--color-accent-yellow)] peer-focus:ring-offset-1 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed" />
        <span className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-5 shadow-sm" />
      </label>

      {(label || description) && (
        <div className="flex-1">
          {label && (
            <label
              htmlFor={switchId}
              className="block text-sm font-medium text-[var(--color-text-primary)] cursor-pointer select-none"
            >
              {label}
            </label>
          )}
          {description && (
            <p className="mt-0.5 text-sm text-[var(--color-text-muted)]">{description}</p>
          )}
        </div>
      )}
    </div>
  );
});

export { Switch, type SwitchProps };
